import React, { Component } from 'react';
import { ScrollView, StyleSheet, TextInput, Text, View, TouchableOpacity, Image } from 'react-native';
import { Row } from '../../components/Rows';
import { Table, TableWrapper } from '../../components/Table';
import Cell from '../../components/Cell';
import ProductList from '../../components/ProductList';
import images from "../../images/ImagesControl";
import ConfirmedOrderList from './OrderList';
import { Content1, Content2, Content3 } from './Content';
import Faq from './Faq';

class Chapter5 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            widthArr: [70, 150, 100, 100, 60],
            tableHead: ["Item No.", "Product Code (proId)", "Quantity", "Unit", "Delete"],
            tableData: [[1, "Apple", "5", "PCS", "NEW"], [2, "Apple", "7", "PCS", "NEW"]],
            proId: { "Apple": "1", "Banana": "2", "Peach": "3", "Orange": "4" },
            requestTimer: 0,
            requestColor: "#c8e1ff",
            responseState: true,
            responseError: "",
            responseErrors: "",
            intervalId: setInterval(() => {
                this.setState({
                    requestTimer: this.state.requestTimer + 1,
                    requestColor: (this.state.requestTimer === 0) ? "#c8e1ff" : "#FFFFFF"
                });
            }, 500),
            orderValue: "SO001",
            orderInfo: {
                SO001: {
                    id: "1",
                    size: "2",
                },
                SO002: {
                    id: "2",
                    size: "4",
                },
                SO003: {
                    id: "3",
                    size: "3",
                },
            },
            orderResponseHeader: '"id":1, "iRev":1, "code":"SO001", ...',
            orderResponseFooter: '"id":1, "hId":1, "itemNo":"     1, "proId": 1, "bDesc":"Apple", "qty":5.0, ...'
                + '\n"id":2, "hId":1, "itemNo":"     2, "proId": 1, "bDesc":"Apple", "qty":7.0, ...',
        };
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    _clearProFocus(newData) {
        for (let i = 0; i < newData.length; i++) {
            newData[i][4] = "";
        }
    }

    _insertProCode(item) {
        const newData = this.state.tableData;

        this._clearProFocus(newData);

        var rowData = [newData.length + 1, item.code, '', 'PCS', 'NEW'];

        newData.push(rowData);

        this.setState({
            tableData: newData,
            requestTimer: 0
        });
    }

    _onUpdateNumber(text, index, cellIndex) {
        let newData = this.state.tableData;

        this._clearProFocus(newData);

        newData[index][cellIndex] = text;
        newData[index][4] = 'NEW';

        this.setState({
            tableData: newData,
            requestTimer: 0
        });
    }

    _onDelTableData(index) {
        let newData = this.state.tableData;

        newData.splice(index, 1);

        this._clearProFocus(newData);

        // re-assign item No.
        for (let i = 0; i < newData.length; i++) {
            newData[i][0] = i + 1;
            newData[i][4] = "";
        }

        this.setState({
            tableData: newData,
            requestTimer: 0
        });
    }

    _submitRequest() {
        const newData = this.state.tableData;

        var isOk = true;
        var errorLocator = "";
        var errorLocators = "";

        for (let i = 0; i < newData.length; i++) {
            var qtyStr = newData[i][2];

            if (isNaN(qtyStr)) {
                isOk = false;

                if (errorLocator !== "") {
                    errorLocator += ",\n";
                }

                if (errorLocators !== "") {
                    errorLocators += ",\n";
                }

                errorLocator += ("                             ");
                errorLocator += ('{"locator":"sot.qty."' + newData[i][0] + '"}');

                errorLocators += ("                                   ");
                errorLocators += '{'
                errorLocators += ("\n                                      "
                    + '"colName":"qty",'
                    + "\n                                      "
                    + '"id":0,'
                    + "\n                                      "
                    + '"locatorKey":"sot.qty.' + newData[i][0] + '",'
                    + "\n                                      "
                    + '"row":' + newData[i][0] + ','
                    + "\n                                      "
                    + '"tableName":"sot",'
                    + "\n                                      "
                    + '"type":"Field"')
                errorLocators += "\n";
                errorLocators += ("                                   ");
                errorLocators += '}';
            }
        }

        this.setState({
            responseError: errorLocator,
            responseErrors: errorLocators,
            responseState: isOk,
        });
    }

    _changeOrderValue(orderValue) {
        let newData = this.state.tableData;
        let header = '';
        let footer = '';

        if (orderValue === "SO001") {
            newData = [
                [1, "Apple", "5", "PCS", "NEW"],
                [2, "Apple", "7", "PCS", "NEW"]
            ];

            header = '"id":1, "iRev":1, "code":"SO001", ...';
            footer = '"id":1, "hId":1, "itemNo":"     1, "proId": 1, "bDesc":"Apple", "qty":5.0, ...'
                + '\n"id":2, "hId":1, "itemNo":"     2, "proId": 1, "bDesc":"Apple", "qty":7.0, ...';
        } else if (orderValue === "SO002") {
            newData = [
                [1, "Peach", "5", "PCS", "NEW"],
                [2, "Apple", "21", "PCS", "NEW"],
                [3, "Orange", "10", "PCS", "NEW"],
                [4, "Apple", "5", "PCS", "NEW"]
            ];

            header = '"id":2, "iRev":1, "code":"SO002", ...';
            footer = '"id":3, "hId":2, "itemNo":"     1, "proId": 3, "bDesc":"Peach", "qty":5.0, ...'
                + '\n"id":4, "hId":2, "itemNo":"     2, "proId": 1, "bDesc":"Apple", "qty":21.0, ...'
                + '\n"id":5, "hId":2, "itemNo":"     3, "proId": 4, "bDesc":"Orange", "qty":10.0, ...'
                + '\n"id":6, "hId":2, "itemNo":"     4, "proId": 1, "bDesc":"Apple", "qty":5.0, ...';
        } else if (orderValue === "SO003") {
            newData = [
                [1, "Apple", "17", "PCS", "NEW"],
                [2, "Banana", "5", "PCS", "NEW"],
                [3, "Peach", "16", "PCS", "NEW"]
            ];

            header = '"id":3, "iRev":1, "code":"SO003", ...';
            footer = '"id":7, "hId":3, "itemNo":"     1, "proId": 1, "bDesc":"Apple", "qty":17.0, ...'
                + '\n"id":8, "hId":3, "itemNo":"     2, "proId": 2, "bDesc":"Banana", "qty":5.0, ...'
                + '\n"id":9, "hId":3, "itemNo":"     3, "proId": 3, "bDesc":"Peach", "qty":16.0, ...';
        }

        this.setState({
            tableData: newData,
            orderValue: orderValue,
            orderResponseHeader: header,
            orderResponseFooter: footer
        });
    }

    _changePages(id) {
        this.props.onPress(id);
    }

    render() {
        const state = this.state;

        const element = (data, index, cellIndex) => (
            <View>
                <TextInput style={styles.textInput} value={state.tableData[index][cellIndex]}
                    onChangeText={(text) => this._onUpdateNumber(text, index, cellIndex)} />
            </View>
        );

        const element2 = (data, index, cellIndex) => (
            <TouchableOpacity onPress={() => this._onDelTableData(index)}>
                <View style={styles.delBtn}>
                    <Text style={styles.delBtnText}>DEL</Text>
                </View>
            </TouchableOpacity>
        );

        const responseOK = () => (
            <Text style={{ paddingLeft: 40, paddingTop: 20, paddingBottom: 20 }}>
                {
                    "HttpResponseProxy{"
                    + "\nHTTP/1.1 200 OK"
                    + "\n["
                    + "\n       Connection: keep-alive,"
                    + "\n       X-Powered-By: Undertow/1,"
                    + "\n       Server: WildFly/9,"
                    + "\n       Content-Type: application/json;charset=UTF-8,"
                    + "\n       Content-Length: 2,"
                    + "\n       Date: Thu, 09 Aug 2018 04:59:18 GMT"
                    + "\n]"
                    + "\n\n"
                    + "ResponseEntityProxy {"
                    + "\n["
                    + "\n       Content-Type: application/json;charset=UTF-8,"
                    + "\n       Content-Length: 2,"
                    + "\n       Chunked: false"
                    + "\n]}}"
                }
            </Text>
        );

        const responseFail = () => (
            <Text style={{ paddingLeft: 40, paddingTop: 20, paddingBottom: 20 }}>
                {
                    "HttpResponseProxy{"
                    + "\nHTTP/1.1 400 Bad Request"
                    + "\n["
                    + "\n       Connection: keep-alive,"
                    + "\n       X-Powered-By: Undertow/1,"
                    + "\n       error_info: {"
                    + '\n               "autoClose":true,'
                    + '\n               "closable":true,'
                    + '\n               "delayClose":3000,'
                    + '\n               "detailSet":false,'
                    + '\n               "htmlMessage":false,'
                    + '\n               "locator": ['
                    + "\n"
                }
                <Text style={{ color: 'purple', fontWeight: 'bold' }}>
                    {state.responseError}
                </Text>
                {
                    '\n               ],'
                    + '\n               "messageData": {'
                    + '\n                       "exception":"",'
                    + '\n                       "htmlMessage":false,'
                    + '\n                       "id":101203,'
                    + '\n                       "info":"invalid logic",'
                    + '\n                       "info_desc":"<Quantity> of <Product> cannot be 0",'
                    + '\n                       "jsonStr":"",'
                    + '\n                       "key":"ce01_core_101203",'
                    + '\n                       "locators": ['
                    + "\n"
                }
                <Text style={{ color: 'purple', fontWeight: 'bold' }}>
                    {state.responseErrors}
                </Text>
                {
                    '\n                       ],'
                    + '\n                       "pass":false,'
                    + '\n                       "trace":"'
                    + '\n                               [TradeModuleChecker.checkSetting_791]-'
                    + '\n                               [CheckerLib.runChecker_225]-'
                    + '\n                               [CawEntityCurdAction.updateEntity_107]-'
                    + '\n                               [CawEntityInterceptor.logCall_42]-'
                    + '\n                               [view129.updateEntity_-1]'
                    + '\n                       ",'
                    + '\n                       "type":"Error"'
                    + '\n               },'
                    + '\n               "messageKey":"ce01_core_101203",'
                    + '\n               "type":"ERROR"'
                    + '\n       },'
                    + '\n       error_id: 1'
                    + '\n       Server: WildFly/9,'
                    + '\n       Content-Type: application/json;charset=UTF-8,'
                    + '\n       Content-Length: 0,'
                    + '\n       Date: Thu, 09 Aug 2018 04:59:18 GMT'
                    + '\n]'
                    + "\n\n"
                    + "ResponseEntityProxy {"
                    + "\n["
                    + "\n       Content-Type: application/json;charset=UTF-8,"
                    + "\n       Content-Length: 0,"
                    + "\n       Chunked: false"
                    + "\n"
                    + "]}}"
                }
            </Text>
        );

        return (
            <View style={styles.container}>

                <Content1 />

                <View style={{ paddingBottom: 20 }}>
                    <ConfirmedOrderList onPress={this._changeOrderValue.bind(this)} />
                </View>

                <View style={styles.shopContainer}>
                    <View style={styles.shopContent}>
                        <Image source={images.logo} style={styles.shopLogoImage} />
                        <Text style={styles.shopLogoTitle}>
                            {"ABC Fruit Company"}
                        </Text>
                    </View>
                    <View style={styles.shopScroll}>
                        <ProductList onPress={this._insertProCode.bind(this)} />
                        <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                            <Row data={state.tableHead} style={styles.head} widthArr={state.widthArr} textStyle={styles.tableText} />
                            <ScrollView>
                                {state.tableData.map((rowData, index) => (
                                    <TableWrapper key={index} style={styles.row}>
                                        {rowData.map((cellData, cellIndex) => (
                                            <Cell key={cellIndex}
                                                data={(cellIndex === 2)
                                                    ? element(cellData, index, cellIndex)
                                                    : ((cellIndex === 4)
                                                        ? element2(cellData, index, cellIndex)
                                                        : cellData)
                                                }
                                                style={styles.tableBorder}
                                                textStyle={styles.tableText}
                                                width={state.widthArr[cellIndex]}
                                                height={40} />
                                        ))}
                                    </TableWrapper>
                                ))}
                            </ScrollView>
                        </Table>
                    </View>
                </View>

                <Content2 onPress={this._changePages.bind(this)} />

                <View style={{ paddingBottom: 20 }}>
                    <ConfirmedOrderList onPress={this._changeOrderValue.bind(this)} />
                </View>

                <View style={styles.shopContainer}>
                    <View style={styles.shopContent}>
                        <Image source={images.logo} style={styles.shopLogoImage} />
                        <Text style={styles.shopLogoTitle}>
                            {"ABC Fruit Company"}
                        </Text>
                    </View>
                    <View style={styles.shopScroll}>
                        <ProductList onPress={this._insertProCode.bind(this)} />
                        <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                            <Row data={state.tableHead} style={styles.head} widthArr={state.widthArr} textStyle={styles.tableText} />
                            <ScrollView>
                                {state.tableData.map((rowData, index) => (
                                    <TableWrapper key={index} style={styles.row}>
                                        {rowData.map((cellData, cellIndex) => (
                                            <Cell key={cellIndex}
                                                data={(cellIndex === 2)
                                                    ? element(cellData, index, cellIndex)
                                                    : ((cellIndex === 4)
                                                        ? element2(cellData, index, cellIndex)
                                                        : cellData)
                                                }
                                                style={styles.tableBorder}
                                                textStyle={styles.tableText}
                                                width={state.widthArr[cellIndex]}
                                                height={40} />
                                        ))}
                                    </TableWrapper>
                                ))}
                            </ScrollView>
                        </Table>
                    </View>
                </View>
                <TouchableOpacity onPress={() => this._submitRequest()}>
                    <View style={styles.submitBtn}>
                        <Text style={styles.submitBtnText}>Submit</Text>
                    </View>
                </TouchableOpacity>

                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {'Sample request to get info of Sales Order where Id = '}
                    <Text style={[{ color: 'purple', fontWeight: 'bold' }]}>
                        {'“' + state.orderInfo[state.orderValue].id + '"'}
                    </Text>
                </Text>
                <View style={styles.border}>
                    <Text style={[styles.text, { paddingLeft: 20, paddingBottom: 20 }]}>
                        {
                            "GET"
                            + "\n" +
                            "http://[server]/jsf/rfws/entity/read/"
                        }
                        <Text style={[{ color: 'purple', fontWeight: 'bold' }]}>
                            {
                                "oldso?menuCode=oldso&id=" + state.orderInfo[state.orderValue].id
                            }
                        </Text>
                    </Text>
                </View>

                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {"Sample Response"}
                </Text>
                <View style={styles.border}>
                    <Text style={[styles.text, { paddingLeft: 20 }]}>
                        {
                            '"mainso":"{'
                            + '\n       "size":1,'
                            + '\n       "values":['
                            + '\n               {\n'
                        }
                    </Text>
                    <Text style={[{ color: 'purple', fontWeight: 'bold', paddingLeft: 100 }]}>
                        {state.orderResponseHeader}
                    </Text>
                    <Text style={{ paddingLeft: 20 }}>
                        {
                            '               }'
                            + '\n       ]'
                            + '\n},'
                            + '\n"sot":"{'
                            + '\n       "size":'
                        }
                        <Text style={{ color: 'purple', fontWeight: 'bold' }}>
                            {
                                state.orderInfo[state.orderValue].size
                            }
                        </Text>
                        {
                            ','
                            + '\n       "values":['
                            + '\n               {\n'
                        }
                    </Text>
                    <Text style={[{ color: 'purple', fontWeight: 'bold', paddingLeft: 100 }]}>
                        {state.orderResponseFooter}
                    </Text>
                    <Text style={{ paddingLeft: 20, paddingBottom: 20 }}>
                        {
                            '               }'
                            + '\n       ]'
                            + '\n}'
                        }
                    </Text>
                </View>

                <Content3 onPress={this._changePages.bind(this)} />

                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {"Corresponding Request:"}
                </Text>
                <View style={styles.border}>
                    <Text style={{ paddingLeft: 40, paddingTop: 20 }}>
                        {
                            'MediaType jsonMT = MediaType.parse("application/json; charset=utf-8");'
                            + "\n\n"
                            + 'RequestBody rb = RequestBody.create(jsonMT,'
                        }
                    </Text>
                    <View style={{ paddingLeft: 80 }}>
                        <Text>
                            {
                                '{'
                                + '\n       "sot": {'
                                + '\n               "values": ['
                            }
                        </Text>
                        {
                            state.tableData.map((rowData, index) => (
                                <Text key={index} style={
                                    (rowData[4] === 'NEW')
                                        ? { paddingLeft: 100, color: 'purple', fontWeight: 'bold', backgroundColor: this.state.requestColor }
                                        : { paddingLeft: 100, color: 'purple', fontWeight: 'bold', backgroundColor: "#FFFFFF" }
                                }>
                                    {
                                        '{ '
                                        + '"proId": "' + this.state.proId[rowData[1]] + '",  '
                                        + '"qty": "' + rowData[2] + '",  '
                                        + '"unitId": "1" }'
                                        + ((state.tableData[index + 1] !== undefined) ? "," : "")
                                    }
                                </Text>
                            ))
                        }
                        <Text>
                            {
                                '               ]'
                                + '\n       },'
                            }
                        </Text>
                        <Text>
                            {
                                '       "mainso": {'
                                + '\n               "values": ['
                                + '\n                           {'
                                + '\n                               "flowTypeId": "1",'
                                + '\n                               "code": "OLDSOOO1",'
                                + '\n                               "tDate": "2018-01-01 00:00:00",'
                                + '\n                               "cusId": "1", "curId": "1",'
                                + '\n                               "rate": "1", "staffId": "1"'
                                + '\n                           }'
                                + '\n               ]'
                                + '\n       }'
                                + '\n}'
                            }
                        </Text>
                    </View>
                    <Text style={{ paddingLeft: 40, paddingBottom: 20 }}>
                        {
                            '\nRequest request = new Request.Builder()'
                            + '\n       .url("http://[server]]/jsf/rfws/entity/s/save/oldso?menuCode=oldso")'
                            + '\n       .put(formBody)'
                            + '\n       .addHeader("authorization", "Bearer MjZhZGNjMDctODVhZS00MmE0LWI3ZmEtNzRhMTQ")'
                            + '\n       .addHeader("client_id", "C-SGF2aWQncyBhcHBsaWNhdGlvbjIwMTctMDItMTAxNjc=")'
                            + '\n       .addHeader("cache-control", "no-cache")'
                            + '\n       .build();'
                            + '\n\nResponse response = client.newCall(request).execute();'
                        }
                    </Text>
                </View>

                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {"Corresponding Response:"}
                </Text>
                <View style={styles.border}>
                    <View>
                        {
                            (state.responseState)
                                ? responseOK()
                                : responseFail()
                        }
                    </View>
                </View>

                <View style={styles.faqContainer}>
                    <TextInput style={styles.subheading}
                        ref={(ref) => this.faqtitle = ref}
                        value={"FAQ"}>
                    </TextInput>
                    <Faq />
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        width: 700,
    },
    shopContainer: {
        flexDirection: 'column',
        borderWidth: 1,
        borderStyle: 'dashed',
        borderRadius: 20,
        alignItems: 'center',
        height: 430,
    },
    shopContent: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 20,
    },
    shopLogoTitle: {
        fontSize: 25,
        fontWeight: 'bold',
        paddingLeft: 20,
        fontStyle: 'iTalic'
    },
    shopLogoImage: {
        height: 60,
        width: 180
    },
    shopScroll: {
        paddingTop: 20,
        height: 320,
        flexDirection: 'row',
        width: 650,
    },
    tableBorder: {
        borderWidth: 2,
        borderColor: '#c8e1ff'
    },
    subheading: {
        paddingTop: 20,
        fontSize: 20,
        fontWeight: 'bold',
    },
    text: {
        paddingTop: 20,
    },
    hyperlink: {
        fontStyle: 'iTalic',
        color: 'blue',
        textDecorationLine: 'underline',
    },
    tableText: {
        margin: 6,
        fontSize: 10
    },
    submitContainer: {
        paddingTop: 50
    },
    submitBtn: {
        height: 40,
        borderWidth: 1,
        backgroundColor: '#c8e1ff',
        borderRadius: 15,
        justifyContent: 'center',
        alignItems: 'center',
    },
    submitBtnText: {
        fontSize: 15,
        textAlign: 'center',
    },
    border: {
        borderWidth: 1,
    },
    requestContent: {
        //height: 500,
        padding: 20,
    },
    responseContent: {
        height: 550,
        padding: 20,
    },
    faqContainer: {
        paddingBottom: 20,
    },
    head: {
        height: 40,
        backgroundColor: '#c8e1ff',
    },
    textInput: {
        margin: 6,
        backgroundColor: 'transparent',
        borderWidth: 2,
        borderColor: '#c8e1ff',
        fontSize: 10,
        textAlign: 'center'
    },
    delBtn: {
        width: 50,
        height: 20,
        backgroundColor: '#c8e1ff',
        borderRadius: 5,
        alignSelf: 'center',
    },
    delBtnText: {
        textAlign: 'center',
        color: '#4f603c',
    },
    row: {
        flexDirection: 'row',
        overflow: 'hidden',
        backgroundColor: '#f1f8ff',
    },
});

export default Chapter5;



// WEBPACK FOOTER //
// ./src/pages/ch5/Chapter5.js